var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4714_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4.032C4 4.048 5.38133 6.032 7.072 8.44267C8.768 10.8533 10.1493 12.848 10.1547 12.8853C10.16 12.9173 8.80533 14.4853 7.14667 16.3733C5.488 18.2613 4.10133 19.8507 4.064 19.904C3.99467 19.9947 4.02667 20 4.73067 20H5.472L8.16 16.9387C9.63733 15.2533 10.864 13.8827 10.88 13.8933C10.896 13.904 11.872 15.28 13.0453 16.9547L15.1733 19.9947L17.5893 20C18.912 20 20 19.9893 20 19.9733C20 19.9627 18.56 17.8987 16.7947 15.3867C15.0347 12.8747 13.6053 10.7893 13.616 10.7573C13.6373 10.7093 17.008 6.85867 19.2107 4.35733L19.5307 4L18.768 4.00533L18 4.01067L15.4667 6.90667C14.0747 8.50133 12.9227 9.808 12.9067 9.808C12.8907 9.808 11.968 8.512 10.8533 6.91733L8.82667 4.02667L6.41067 4.01067C5.088 4.00533 4 4.01067 4 4.032ZM12.9867 11.9573C15.6853 15.7387 17.9147 18.8693 17.936 18.912C17.9733 18.976 17.8133 18.9867 16.9493 18.9867H15.92L10.9707 12.0587C8.25067 8.25067 6.02667 5.12 6.02667 5.09867C6.02667 5.08267 6.49067 5.06667 7.056 5.06667L8.08 5.072L12.9867 11.9573Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4714_869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNew);
export default __webpack_public_path__ + "static/media/twitter-new.09c7b3397e8cf110d24822dee46151cc.svg";
export { ForwardRef as ReactComponent };